var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",attrs:{"role":"status","aria-live":"polite","aria-busy":"true"}},[_c('div',{staticClass:"loading-spinner",attrs:{"aria-hidden":"true"}}),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }